import { State } from '@cemex/cmx-client-layout';
import { createFeatureSelector } from '@ngrx/store';
import * as fromCxShipmentLocations from './cx-shipment-location.reducer';

export const cxShipmentLocationKey = 'cxShipmentLocations';
export const reducers = fromCxShipmentLocations.reducer;

export interface CxShipmentLocationsState extends State {
  [cxShipmentLocationKey]: fromCxShipmentLocations.CxShipmentLocationState;
}

export const selectShipmentLocationsState =
  createFeatureSelector<fromCxShipmentLocations.CxShipmentLocationState>(cxShipmentLocationKey);
